import React from 'react';

export default function Multilingual (
  component,
) {
  if (!component) throw new Error('undefined component');
  return class extends React.Component {
    constructor(props) {
      super(props);
      const locales = this.props.availableLocales || ['en'];
      this.state = {
        activeLocale: this.props.initialLocale || locales[0],
      };
    };

    handleLocaleSelect(e) {
      e.preventDefault();
      this.setState({activeLocale: e.target.text})
      if (this.props.onLocaleChange) this.props.onLocaleChange(e.target.text);
    };

    handleChange(field) {
      const props = this.props;
      const newValue = {...props.value, [field.name]: field.value};
      if (props.onChange) props.onChange({name: props.name, value: newValue});
    };

    render() {
      const props = this.props;
      const id = props.id || 'input-' + props.name;
      const label = props.label || props.name;
      const value = props.value || {};
      const locales = props.availableLocales || ['en'];
      const locale = this.state.activeLocale;
      const tabs = locales.map((l, i) => {
        const className = (l === this.state.activeLocale) ? 'active' : null;
        const style = [undefined, null, ''].indexOf(value[l]) !== -1 ? {color: '#bbb'} : null;
        return (
          <li className={className} key={i} data-lang={l}>
            <a href="#"
              onClick={this.handleLocaleSelect.bind(this)}
              style={style}
            >{l}</a>
          </li>
        );
      });
      return (
        <div className="form-group" data-uid={ props.uid }>
          { label ? <label>{label}</label> : null }
          <div className="" style={{paddingLeft: 0}}>
            <ul className="nav nav-tabs col-sm-12">{tabs}</ul>
            {React.createElement(component,{
              ...props,
              ref: locale,
              name: locale,
              value: value[locale],
              locale: locale,
              mode: props.mode,
              label: null,
              onChange: this.handleChange.bind(this),
            })}
          </div>
        </div>
      );
    }
  };
};



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/Multilingual.jsx